export const ONBOARDING_EVENTS = {
  STARTED: 'onboarding_started',
  INTENT_SELECTED: 'intent_selected',
  AUDIENCE_SELECTED: 'audience_selected',
  CHIP_CLICKED: 'starter_chip_clicked',
  SURPRISE_ME: 'surprise_me_clicked',
  VOICE_CLICKED: 'voice_input_clicked',
  MEMORY_SUBMITTED: 'memory_submitted',
  PREVIEW_GENERATED: 'preview_generated',
  SIGNUP_VIEWED: 'signup_viewed',
  SIGNUP_COMPLETED: 'signup_completed',
  FEEDBACK_SHOWN: 'feedback_modal_shown',
  FEEDBACK_SUBMITTED: 'feedback_submitted',
  ABANDONED: 'onboarding_abandoned',
};

export const INTENT_OPTIONS = [
  { id: 'memoir', label: 'My memoir' },
  { id: 'family', label: 'A family story' },
  { id: 'tribute', label: 'A tribute' },
  { id: 'chapter', label: 'A life chapter' },
  { id: 'unsure', label: 'Not sure yet' },
];

export const AUDIENCE_OPTIONS = [
  { id: 'myself', label: 'Myself' },
  { id: 'children', label: 'My children' },
  { id: 'family', label: 'My family' },
  { id: 'future', label: 'Future generations' },
  { id: 'miss', label: 'Someone I miss' },
];

export const STARTER_CHIPS = [
  'I still remember the day…',
  'There was this person who…',
  'Every time I smell / hear / see…',
  "One place I'll never forget is…",
  "I didn't understand it then, but…",
  'The thing I remember most is…',
];

export const LOADING_MESSAGES = [
  'Shaping your memory…',
  'Finding the heart of the story…',
  'Preparing your first draft…',
  'Organizing the feeling behind the memory…',
];

export const FEEDBACK_REASONS = [
  { id: 'see_more', label: 'I wanted to see more' },
  { id: 'overwhelming', label: 'Too overwhelming' },
  { id: 'not_personal', label: 'Not personal enough' },
  { id: 'exploring', label: 'Just exploring' },
  { id: 'price', label: 'Price or subscription concern' },
  { id: 'other', label: 'Other' },
];

// localStorage keys — centralized so cleanup is consistent
export const STORAGE_KEYS = {
  SESSION_ID: 'onboarding_session_id',
  PREVIEW: 'onboarding_preview',
};

export function clearOnboardingStorage() {
  localStorage.removeItem(STORAGE_KEYS.SESSION_ID);
  localStorage.removeItem(STORAGE_KEYS.PREVIEW);
}

// Returns personalized placeholder based on intent + audience
export function getMemoryPlaceholder(intent, audience) {
  if (intent === 'tribute' && audience === 'miss') {
    return 'Tell me something about them you never want to forget.';
  }
  if (intent === 'family' && audience === 'children') {
    return "Share one family moment you'd want your children to remember.";
  }
  if (intent === 'memoir') {
    return 'Share one moment from your life that still comes back to you.';
  }
  if (intent === 'unsure') {
    return 'Start with any small memory — a person, place, smell, sound, or moment.';
  }
  return 'Tell me about a person, a place, or a moment you keep coming back to.';
}
